var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnlineAppointment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5105_24202)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5105_24202",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 73,
    height: 73
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.166992 -0.00389862H72.167V71.9961H0.166992V-0.00389862Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5105_24202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.1123 47.5406V56.0098C71.1123 58.3384 69.2237 60.2285 66.8935 60.2285H5.44043C3.11027 60.2285 1.22168 58.3384 1.22168 56.0098V20.2009C1.22168 17.8721 3.11027 15.9821 5.44043 15.9821H17.5567",
    stroke: "#01A5AF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7793 15.9806H66.8955C69.2257 15.9806 71.1143 17.8706 71.1143 20.1993V42.6172",
    stroke: "#01A5AF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5567 20.2009H5.8623C5.62929 20.2009 5.44043 20.3899 5.44043 20.6227V56.0098H66.4717C66.7047 56.0098 66.8935 55.8208 66.8935 55.5879V20.6227C66.8935 20.3899 66.7047 20.2009 66.4717 20.2009H54.7773",
    stroke: "#01A5AF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2783 60.2271V66.7217",
    stroke: "#01A5AF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0557 66.7217V60.2271",
    stroke: "#01A5AF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6663 66.7217H29.6719C27.5749 66.7217 25.875 68.4216 25.875 70.5186C25.875 70.7516 26.0639 70.9404 26.2969 70.9404H46.0413C46.2743 70.9404 46.4632 70.7516 46.4632 70.5186C46.4632 68.4216 44.7633 66.7217 42.6663 66.7217Z",
    stroke: "#01A5AF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5576 56.0098V5.27001C17.5576 2.94 19.4465 1.05126 21.7764 1.05126H50.5584C52.8882 1.05126 54.7771 2.94 54.7771 5.27001V56.0098",
    stroke: "#01A5AF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7255 9.85349C30.8026 8.29916 33.3791 7.37793 36.167 7.37793C43.0292 7.37793 48.6123 12.9609 48.6123 19.8232C48.6123 26.6855 43.0292 32.2686 36.167 32.2686C29.3046 32.2686 23.7217 26.6855 23.7217 19.8232C23.7217 17.5188 24.3513 15.3585 25.4473 13.5057",
    stroke: "#01A5AF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0415 25.3291C33.3213 25.3291 32.6013 25.0552 32.053 24.507L29.7163 22.1702C28.8927 21.3465 28.8927 20.0109 29.7165 19.1872C30.5403 18.3635 31.8759 18.3632 32.6996 19.1872L33.7433 20.231C33.9081 20.3958 34.1751 20.3958 34.34 20.231L39.5919 14.9791C40.395 14.176 41.7032 14.102 42.5433 14.8665C43.4402 15.6825 43.4648 17.0723 42.6171 17.9199L36.0303 24.5067C35.482 25.055 34.7617 25.3291 34.0415 25.3291Z",
    stroke: "#01A5AF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0234 39.1592H48.3113",
    stroke: "#01A5AF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0234 45.4873H48.3113",
    stroke: "#01A5AF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5105_24202"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white",
    transform: "translate(0.166992)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineAppointment);
export default __webpack_public_path__ + "static/media/online-appointment.690d61cb8d29c60e445b862ea6853e78.svg";
export { ForwardRef as ReactComponent };